// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"388e2a0c","776":"04b53853"}[chunkId] + ".chunk.css";
};